var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrainstromIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E8E6FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0AF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 6.667V7.5M7.5 15h-.833m2.916-5.417-.5-.5m11.334.5.5-.5M23.333 15H22.5m-9.167 1.25h3.334m-1.667 0v4.166m2.917-1.355a5 5 0 1 0-5.833 0v1.605c0 .934 0 1.4.181 1.757.16.314.415.569.728.729.357.181.824.181 1.757.181h.5c.933 0 1.4 0 1.757-.181a1.67 1.67 0 0 0 .728-.729c.182-.356.182-.823.182-1.756V19.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainstromIcon);
export default __webpack_public_path__ + "static/media/brainstrom-icon.80e509a0adb0536dc81c5c43886271e2.svg";
export { ForwardRef as ReactComponent };